(function () {
  "use strict";
  function initialiseCompatibilityGuide() {
    const f = window.PesadoCompatibilityData;
    if (!f || f.managerUnavailable || !f.products || !f.brands) return false;
    const j =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg>',
      Ie =
        '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="22"></circle><circle cx="32" cy="32" r="15"></circle><path d="M32 10v44M10 32h44"></path></svg>',
      Ee = {
        IT: "#0c8b3b",
        AU: "#1d3a8a",
        DE: "#cf2200",
        ES: "#c5a200",
        US: "#2233aa",
        GB: "#1d3a8a",
        IN: "#cf6c00",
        CH: "#cf0000",
        CA: "#cf0000",
        NL: "#cf6c00",
        CN: "#cf0000",
      };
    function l(s) {
      return String(s != null ? s : "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }
    function it(s) {
      const g = document.createElement("div");
      return ((g.innerHTML = s || ""), g.textContent || "");
    }
    function m(s) {
      return String(s || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
    }
    function N(s, g) {
      const u = m(s),
        v = m(g);
      return v
        ? u.includes(v) || u.replace(/\s+/g, "").includes(v.replace(/\s+/g, ""))
        : !0;
    }
    function Be(s) {
      if (s.dataset.pcgInitialised === "true") return;
      s.dataset.pcgInitialised = "true";
      const g = s.querySelector("[data-pcg-grid]"),
        u = s.querySelector("[data-pcg-count]"),
        v = s.querySelector("[data-pcg-search]"),
        E = s.querySelector("[data-pcg-search-form]"),
        _ = s.querySelector("[data-pcg-overlays]"),
        Ne = s.querySelector("[data-pcg-no-results-form-template]"),
        de = s.querySelector("[data-pcg-toast]"),
        lt = s.querySelector("[data-pcg-index]"),
        le = (s.dataset.rootUrl || "/").replace(/\/?$/, "/"),
        ce = s.dataset.currency || "AUD",
        ct = s.dataset.locale || "en-AU",
        pt = s.dataset.showBundle === "true",
        ut = s.dataset.showCrossSell === "true",
        Y = s.dataset.showRewards === "true",
        qe = Number(s.dataset.freeShippingThreshold || 0),
        Te = Number(s.getAttribute("data-discount-10-threshold") || 0),
        Oe = Number(s.getAttribute("data-discount-15-threshold") || 0),
        mt = s.dataset.kitShippingCopy || "Free shipping unlocked",
        gt = s.dataset.kitDiscount15Copy || "15% reward unlocked",
        ea = s.dataset.kitAfterCopy || "Kit after reward",
        C = s.dataset.pcgLayout === "v3",
        q = s.dataset.pcgStandalone === "true",
        Ve =
          window.performance &&
          typeof window.performance.getEntriesByType == "function"
            ? window.performance.getEntriesByType("navigation")[0]
            : null,
        bt = Ve
          ? Ve.type === "reload"
          : !!(
              window.performance &&
              window.performance.navigation &&
              window.performance.navigation.type === 1
            );
      if (C && bt) {
        "scrollRestoration" in window.history &&
          (window.history.scrollRestoration = "manual");
        const e = () => window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        (e(),
          window.requestAnimationFrame(e),
          window.addEventListener("pageshow", e, { once: !0 }),
          window.addEventListener("load", e, { once: !0 }));
      }
      const Re = s.dataset.videoDirectory || "",
        je = new Map();
      let De = 0,
        Ue = null;
      const a = {
          query: "",
          tier: "all",
          v3Brand: null,
          v3Letter: "all",
          brand: null,
          model: null,
          product: null,
          video: null,
          noResultsQuery: "",
          noResultsFormOpen: !1,
          pdpQty: 1,
          pdpVariant: null,
          pdpSelections: [],
          pdpBase: "HYBRID",
          pdpMode: "MODULAR",
          pdpBody: "Black",
          pdpEnd: "Black",
          pdpFull: "Oak",
          pdpMediaIndex: 0,
          pdpBaseProducts: {},
          pdpBaseStatus: {},
          pdpError: "",
          pdpFitLabel: "",
          pdpPreviewHintShown: !1,
          pdpPreviewHintActive: !1,
          cart: null,
          toastTimer: null,
          lastFocus: null,
          productFocus: null,
        },
        pe = window.PesadoUpgradeAnalytics;
      !q &&
        pe &&
        typeof pe.track == "function" &&
        pe.track("compatibility_page_view", { layout: C ? "v3" : "legacy" });
      function P(e, t) {
        if (e == null || Number.isNaN(Number(e))) return "Loading\u2026";
        try {
          return new Intl.NumberFormat(ct, {
            style: "currency",
            currency: t || (a.cart && a.cart.currency) || ce,
            maximumFractionDigits: Number(e) % 100 === 0 ? 0 : 2,
          }).format(Number(e) / 100);
        } catch (n) {
          return "$" + (Number(e) / 100).toFixed(2);
        }
      }
      function ft(e, t) {
        if (e == null)
          return (
            '<div class="pcg__bundle-price"><strong>' + l(t) + "</strong></div>"
          );
        const n = [];
        Y && qe && e >= qe && n.push("<span>" + l(mt) + "</span>");
        let o = 0;
        Y && Oe && e >= Oe
          ? ((o = 15), n.push("<span>" + l(gt) + "</span>"))
          : Y &&
            Te &&
            e >= Te &&
            ((o = 10), n.push("<span>10% reward unlocked</span>"));
        const r = Math.round(e * (1 - o / 100)),
          i = Math.max(0, e - r),
          d = o
            ? "<strong>" +
              P(r) +
              "</strong><span>Your kit price with " +
              o +
              "% reward</span><del>" +
              P(e) +
              "</del><small>You save " +
              P(i) +
              "</small>"
            : "<strong>" + P(e) + "</strong><span>Complete kit price</span>",
          c =
            Y && n.length
              ? '<div class="pcg__bundle-rewards">' + n.join("") + "</div>"
              : "";
        return '<div class="pcg__bundle-price">' + d + "</div>" + c;
      }
      function ue(e) {
        return le + String(e || "").replace(/^\//, "");
      }
      function vt() {
        if (
          window.PesadoCartCompanion &&
          typeof window.PesadoCartCompanion.open == "function"
        ) {
          window.PesadoCartCompanion.open();
          return;
        }
        document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
      }
      function K(e) {
        return ue("products/" + e.handle);
      }
      function ht() {
        const e = m(a.query);
        return f.brands.filter((t) =>
          (a.tier !== "all" && t.tier !== a.tier) ||
          (C &&
            a.v3Letter !== "all" &&
            t.name.charAt(0).toUpperCase() !== a.v3Letter)
            ? !1
            : e
              ? N(t.name, e) || t.models.some((n) => N(n.name, e))
              : !0,
        );
      }
      function yt(e, t) {
        if (!e || !t) return "";
        const n = t.image || "";
        if (n)
          return (
            '<img src="' + l(n) + '" alt="' + l(t.name) + '" loading="lazy">'
          );
        const o = /(^—$|models?|commercial|group|lever|series|54mm|58mm)/i.test(
            t.name,
          ),
          r = e.name
            .split(/\s+/)
            .map((i) => i.charAt(0))
            .join("")
            .slice(0, 3)
            .toUpperCase();
        return (
          '<span class="pcg__v3-model-placeholder" aria-label="No exact machine image available"><b>' +
          l(r) +
          "</b><small>" +
          (o ? "Model group" : "Photo pending") +
          "</small></span>"
        );
      }
      function wt() {
        if (!C) return;
        const e = s.querySelector("[data-pcg-v3-model-wrap]"),
          t = s.querySelector("[data-pcg-v3-models]"),
          n = s.querySelector("[data-pcg-v3-selected-brand]");
        if (!e || !t || !n) return;
        const o = a.v3Brand;
        if (((e.hidden = !o), !o)) {
          t.innerHTML = "";
          return;
        }
        n.textContent = o.name;
        const r = m(a.query),
          i = r && N(o.name, r),
          d = o.models
            .map((c, b) => ({ model: c, index: b }))
            .filter((c) => !r || i || N(c.model.name, r));
        t.innerHTML = d
          .map((c) => {
            const b = c.model,
              S = c.index,
              w = !b.products || !b.products.length,
              k = w
                ? "<small>Not yet mapped</small>"
                : b.screenCompatibility === !1
                  ? "<small>Shower screen compatibility pending</small>"
                  : "<i>View compatible tools &rarr;</i>";
            return (
              '<button type="button" class="pcg__v3-model" data-action="open-v3-model" data-brand="' +
              l(o.slug) +
              '" data-model="' +
              S +
              '"' +
              (w ? " disabled" : "") +
              ">" +
              yt(o, b, S) +
              '<span class="pcg__v3-model-copy"><b>' +
              l(b.name) +
              "</b>" +
              k +
              "</span></button>"
            );
          })
          .join("");
      }
      function _t() {
        if (!C) return;
        const e = s.querySelector("[data-pcg-v3-alphabet]");
        if (!e) return;
        const t = Array.from(
          new Set(f.brands.map((n) => n.name.charAt(0).toUpperCase())),
        ).sort();
        e.innerHTML =
          '<button type="button" class="' +
          (a.v3Letter === "all" ? "is-active" : "") +
          '" data-action="v3-letter" data-letter="all">All</button>' +
          t
            .map(
              (n) =>
                '<button type="button" class="' +
                (a.v3Letter === n ? "is-active" : "") +
                '" data-action="v3-letter" data-letter="' +
                n +
                '">' +
                n +
                "</button>",
            )
            .join("");
      }
      function St(e) {
        if (!e.length) {
          g.innerHTML =
            '<div class="pcg__v3-empty"><strong>No matching machine brands.</strong><button type="button" data-action="reset">Show all brands</button></div>';
          return;
        }
        g.innerHTML = e
          .map((t) => {
            const n = a.v3Brand === t,
              o = t.logoDisplay || { scale: 100, offsetX: 0, offsetY: 0 },
              r =
                "--pcg-logo-scale:" +
                Number(o.scale) / 100 +
                ";--pcg-logo-offset-x:" +
                Number(o.offsetX) +
                "%;--pcg-logo-offset-y:" +
                Number(o.offsetY) +
                "%",
              i = t.logo
                ? '<span class="pcg__v3-brand-logo" style="' +
                  r +
                  '"><img src="' +
                  l(t.logo) +
                  '" alt="" loading="lazy"></span>'
                : "",
              d = t.logo ? "" : "<strong>" + l(t.name) + "</strong>",
              c = t.tier === "pro" ? "Commercial" : "Domestic";
            return (
              '<button type="button" class="pcg__v3-brand-card' +
              (t.logo ? " has-logo" : "") +
              (n ? " is-selected" : "") +
              '" data-action="select-v3-brand" data-brand="' +
              l(t.slug) +
              '" aria-label="' +
              l(t.name + ", " + c + ", " + t.models.length + " models") +
              '"><span class="pcg__v3-brand-meta"><span class="pcg__flag" style="--flag:' +
              (Ee[t.country] || "#777") +
              '">' +
              l(t.country) +
              "</span>" +
              (t.tier === "pro" ? "Commercial" : "Domestic") +
              (t.popular ? " <em>Popular</em>" : "") +
              "</span>" +
              i +
              d +
              '<span class="pcg__v3-brand-footer"><span>' +
              t.models.length +
              ' models</span><span aria-hidden="true">&rarr;</span></span></button>'
            );
          })
          .join("");
      }
      function B() {
        const e = ht(),
          t = f.brands.filter((d) => d.tier === "home").length,
          n = f.brands.filter((d) => d.tier === "pro").length,
          o = s.querySelector('[data-pcg-tier="all"]'),
          r = s.querySelector('[data-pcg-tier="home"]'),
          i = s.querySelector('[data-pcg-tier="pro"]');
        if (
          (o && (o.textContent = "All \xB7 " + f.brands.length),
          r && (r.textContent = "Domestic \xB7 " + t),
          i && (i.textContent = "Commercial \xB7 " + n),
          (u.textContent = e.length + " of " + f.brands.length + " showing"),
          (lt.textContent =
            "Index \xB7 " +
            f.brands.length +
            " brands \xB7 " +
            Object.keys(f.products).length +
            " compatible tools"),
          C)
        ) {
          (_t(), wt(), St(e));
          return;
        }
        if (!e.length) {
          g.innerHTML =
            '<div class="pcg__empty"><strong>No matches for \u201C' +
            l(a.query) +
            '\u201D</strong><button type="button" class="pcg__button" data-action="reset">Reset filters</button></div>';
          return;
        }
        g.innerHTML = e
          .map((d) => {
            const c = d.tier === "pro" ? "Commercial" : "Domestic";
            return (
              '<button type="button" class="pcg__tile" data-action="open-brand" data-brand="' +
              l(d.slug) +
              '"><span class="pcg__tile-top pcg__meta"><span class="pcg__flag" style="--flag:' +
              (Ee[d.country] || "#777") +
              '">' +
              l(d.country) +
              "</span><span>" +
              c +
              "</span>" +
              (d.popular
                ? '<span class="pcg__popular">\xB7 Popular</span>'
                : "") +
              '</span><strong class="pcg__brand">' +
              l(d.name) +
              '</strong><span class="pcg__tile-footer"><span>' +
              d.models.length +
              ' models</span><span class="pcg__tile-arrow">' +
              (d.productCount ? d.productCount + " parts" : "View") +
              " \u2192</span></span></button>"
            );
          })
          .join("");
      }
      function me(e, t, n) {
        if (!e || (!n && !e.available)) return !1;
        const o = String(e.id || "");
        if ((t.hiddenVariantIds || []).map(String).includes(o)) return !1;
        const r =
          a.model && a.model.assignments ? a.model.assignments[t.id] : null;
        if (r && r.allowedVariantIds && r.allowedVariantIds.length)
          return r.allowedVariantIds.map(String).includes(o);
        if (!t.tokens || !t.tokens.length) return !0;
        const i = m([e.title, e.public_title, e.sku].join(" "));
        return t.tokens.map(m).every((d) => i.includes(d));
      }
      function D(e) {
        return !e || !e.live
          ? []
          : G(
              (e.live.variants || []).filter((t) => me(t, e)),
              e,
            );
      }
      function U(e) {
        return !e || !e.live
          ? []
          : G(
              (e.live.variants || []).filter((t) => me(t, e, !0)),
              e,
            );
      }
      function G(e, t) {
        const n =
            a.model && a.model.assignments
              ? a.model.assignments[t && t.id]
              : null,
          o = String(
            (n && n.defaultVariantId) || (t && t.preferredVariantId) || "",
          ),
          r = m(t && t.preferredVariantMatch);
        return !r && !o
          ? e
          : e
              .map((i, d) => ({ variant: i, index: d }))
              .sort((i, d) => {
                const c = o && String(i.variant.id) === o,
                  b = o && String(d.variant.id) === o,
                  S = m(
                    [
                      i.variant.title,
                      i.variant.public_title,
                      i.variant.sku,
                    ].join(" "),
                  ).includes(r),
                  w = m(
                    [
                      d.variant.title,
                      d.variant.public_title,
                      d.variant.sku,
                    ].join(" "),
                  ).includes(r);
                return (
                  Number(b) - Number(c) ||
                  Number(w) - Number(S) ||
                  i.index - d.index
                );
              })
              .map((i) => i.variant);
      }
      function He(e, t) {
        return (
          G(
            (e.variants || []).filter((n) => me(n, t)),
            t,
          )[0] || null
        );
      }
      async function H(e) {
        const t = f.products[e];
        if (!t) return t;
        if (!t.handle) return ((t.loadError = !0), t);
        if (t.live) return ((t.variant = He(t.live, t)), t);
        if (t.loadError) return t;
        let n = je.get(t.handle);
        n ||
          ((n = fetch(K(t) + ".js", { credentials: "same-origin" }).then(
            (o) => {
              if (!o.ok) throw new Error("Product unavailable");
              return o.json();
            },
          )),
          je.set(t.handle, n));
        try {
          const o = await n;
          ((t.live = o), (t.variant = He(o, t)));
        } catch (o) {
          t.loadError = !0;
        }
        return t;
      }
      function $(e, t) {
        Promise.all(Array.from(new Set(e)).map(H)).then(() => {
          typeof t == "function" && t();
        });
      }
      function ze(e) {
        const t = D(e);
        return t.length ? t : U(e);
      }
      function Qe(e) {
        const t = ze(e)
          .map((n) => Number(n.price))
          .filter(Number.isFinite);
        return t.length
          ? Math.min.apply(Math, t)
          : e.live
            ? e.live.price
            : null;
      }
      function Ye(e) {
        const t =
            a.model && a.model.assignments
              ? a.model.assignments[e && e.id]
              : null,
          n = String((t && t.defaultVariantId) || "");
        return n && e.variant && String(e.variant.id) === n
          ? P(Number(e.variant.price))
          : (Array.from(
              new Set(
                ze(e)
                  .map((o) => Number(o.price))
                  .filter(Number.isFinite),
              ),
            ).length > 1
              ? "From "
              : "") + P(Qe(e));
      }
      function W(e, t) {
        const n = t || e.variant || U(e)[0];
        return n && n.featured_image && n.featured_image.src
          ? n.featured_image.src
          : e.live && e.live.featured_image
            ? e.live.featured_image
            : "";
      }
      function z(e, t) {
        if (!e) return "";
        const n = t || e.variant || U(e)[0],
          o = e.variantCompatibilityImages || {};
        return (n ? o[String(n.id)] : "") || e.compatibilityImageUrl || "";
      }
      function ge(e, t) {
        if (!e) return "";
        const n = String(e).replace(/^\/\//, "https://");
        return n + (n.includes("?") ? "&" : "?") + "width=" + Number(t || 700);
      }
      function T(e) {
        return !!(e && e.cat === "portafilter");
      }
      function Ke(e) {
        return T(e)
          ? /^pf_breville_/.test(e.id) || /breville/i.test(e.handle || "")
            ? {
                SPOUTED: "spouted-portafilter",
                NAKED: "bottomless-breville-54-58-portafilter-hybrid",
                HYBRID: "hybrid-breville-54-58-portafilter",
              }
            : {
                SPOUTED: "spouted-portafilter",
                NAKED: "pesado-bottomless-naked-portafilter",
                HYBRID: "hybrid-lm-e61-ns-portafilter",
              }
          : {};
      }
      function kt(e) {
        return (
          {
            pf_breville_54: ["breville 54"],
            pf_breville_58: ["breville 58"],
            pf_e61_5mm: ["e61 5mm"],
            pf_lm_e61: ["la marzocco 6mm", "lm 6mm"],
            pf_lm_6mm: ["la marzocco 6mm", "lm 6mm"],
            pf_ns: ["nuova simonelli", "ns"],
            pf_gaggia: ["gaggia"],
          }[e && e.id] || (e && e.tokens ? e.tokens.map(m) : [])
        );
      }
      function be(e, t, n) {
        if (!e || !t) return [];
        const o = kt(e),
          r = a.model && a.model.assignments ? a.model.assignments[e.id] : null,
          i = r && r.allowedVariantIds ? r.allowedVariantIds.map(String) : [],
          d = (t.variants || []).filter((c) => {
            if (!n && !c.available) return !1;
            const b = String(c.id || "");
            if ((e.hiddenVariantIds || []).map(String).includes(b)) return !1;
            if (i.length) return i.includes(b);
            if (!o.length) return !0;
            const S = m([c.title, c.public_title, c.sku].join(" "));
            return o.some((w) => S.includes(m(w)));
          });
        return G(d, e);
      }
      function O() {
        return (
          (a.product && (a.pdpBaseProducts[a.pdpBase] || a.product.live)) ||
          null
        );
      }
      function Q(e) {
        const t = a.product,
          n = O();
        return !t || !n ? [] : T(t) ? be(t, n, e) : e ? U(t) : D(t);
      }
      function L(e) {
        return !e || !e.options || !e.options.length
          ? ""
          : String(e.options[e.options.length - 1] || "");
      }
      function A(e) {
        const t = String(e || "").trim();
        if (/full pom/i.test(t))
          return {
            mode: "ONE-PIECE",
            full: /white/i.test(t) ? "Full White" : "Full Black",
          };
        if (/^oak$/i.test(t)) return { mode: "ONE-PIECE", full: "Oak" };
        if (/^raya$/i.test(t)) return { mode: "ONE-PIECE", full: "Raya" };
        const n = t.split(/\s*[|/]\s*/).filter(Boolean);
        return n.length >= 2
          ? { mode: "MODULAR", body: n[0], end: n.slice(1).join(" / ") }
          : { mode: "MODULAR", body: t || "Black", end: t || "Black" };
      }
      function Ct(e) {
        if (!e) return;
        a.pdpSelections = e.options ? e.options.slice() : [];
        const t = A(L(e));
        ((a.pdpMode = t.mode),
          t.mode === "ONE-PIECE"
            ? (a.pdpFull = t.full)
            : ((a.pdpBody = t.body), (a.pdpEnd = t.end)));
      }
      function V() {
        const e = Q(!1);
        return e.length
          ? T(a.product)
            ? e.find((t) => {
                const n = A(L(t));
                return n.mode !== a.pdpMode
                  ? !1
                  : n.mode === "ONE-PIECE"
                    ? m(n.full) === m(a.pdpFull)
                    : m(n.body) === m(a.pdpBody) && m(n.end) === m(a.pdpEnd);
              }) ||
              e.find((t) => A(L(t)).mode === a.pdpMode) ||
              e[0]
            : e.find((t) =>
                t.options.every((n, o) => n === a.pdpSelections[o]),
              ) || null
          : null;
      }
      function x(e, t) {
        ((a.pdpVariant = e || null), Ct(e));
        const n =
          t && Number.isFinite(t.mediaIndex)
            ? Math.max(0, Number(t.mediaIndex))
            : -1;
        if (n >= 0) {
          a.pdpMediaIndex = n;
          return;
        }
        const o = fe(a.product, O()),
          r = String((e && e.id) || ""),
          i = o.findIndex((d) => d.variant && String(d.variant.id || "") === r);
        a.pdpMediaIndex = i >= 0 ? i : 0;
      }
      function Ge(e) {
        const t = m(e);
        return t.includes("bottomless") || t.includes("naked")
          ? "NAKED"
          : t.includes("spouted")
            ? "SPOUTED"
            : (t.includes("hybrid"), "HYBRID");
      }
      async function It(e) {
        if (!T(e)) return;
        const t = Ke(e),
          n = Ge(e.handle);
        if (
          ((a.pdpBase = n),
          (a.pdpBaseProducts = {}),
          (a.pdpBaseStatus = {}),
          e.live &&
            ((a.pdpBaseProducts[n] = e.live),
            (a.pdpBaseStatus[n] = be(e, e.live, !1).length
              ? "ready"
              : "unavailable")),
          await Promise.all(
            Object.keys(t).map(async (r) => {
              if (!a.pdpBaseProducts[r]) {
                a.pdpBaseStatus[r] = "loading";
                try {
                  const i = await fetch(
                    le + "products/" + encodeURIComponent(t[r]) + ".js",
                    { credentials: "same-origin" },
                  );
                  if (!i.ok) throw new Error("Product unavailable");
                  const d = await i.json();
                  ((a.pdpBaseProducts[r] = d),
                    (a.pdpBaseStatus[r] = be(e, d, !1).length
                      ? "ready"
                      : "unavailable"));
                } catch (i) {
                  a.pdpBaseStatus[r] = "unavailable";
                }
              }
            }),
          ),
          a.product !== e)
        )
          return;
        const o = V();
        (o && x(o), h({ noFocus: !0, stable: !0 }));
      }
      function fe(e, t) {
        const n = [],
          o = new Set(),
          r = (i, d) => {
            const c = i && i.src ? i.src : i;
            if (!c) return;
            const b = String(c)
              .replace(/^https?:/i, "")
              .split("?")[0];
            o.has(b) || (o.add(b), n.push({ source: c, variant: d || null }));
          };
        return (
          Q(!1).forEach((i) => r(i.featured_image, i)),
          n.length || r(W(e, a.pdpVariant), a.pdpVariant),
          n
        );
      }
      function $e(e, t) {
        return fe(e, t).map((n) => n.source);
      }
      function We(e) {
        const t = fe(a.product, O());
        if (!t.length) {
          a.pdpMediaIndex = 0;
          return;
        }
        const n = Math.max(0, Math.min(t.length - 1, Number(e) || 0)),
          o = t[n];
        o.variant && o.variant.available !== !1
          ? x(o.variant, { mediaIndex: n })
          : (a.pdpMediaIndex = n);
      }
      function Et(e) {
        const t = e && e.featured_image;
        return t && t.src ? t.src : t || "";
      }
      function Bt(e, t) {
        const n = A(L(t));
        if (n.mode !== "MODULAR" || m(n.body) !== "white") return "";
        const o = e.find((r) => {
          const i = A(L(r));
          return (
            i.mode === "MODULAR" &&
            m(i.body) === "black" &&
            m(i.end) === m(n.end)
          );
        });
        return Et(o);
      }
      function xt(e, t) {
        const n = [t && t.title, e && e.spec, a.model && a.model.size]
          .filter(Boolean)
          .join(" ")
          .match(/\b(51|53\.5|54|58|58\.5)\s*mm\b/i);
        return n ? n[1] + " mm" : "\u2014";
      }
      function Pt(e, t) {
        return a.model && a.model.name
          ? a.model.name
          : (t && t.options && t.options[0]) ||
              (e && e.spec) ||
              "Selected machine";
      }
      function Mt(e) {
        const t = O();
        return t && t.handle ? le + "products/" + t.handle : K(e);
      }
      async function X(e, t) {
        if (!e || !t || !t.products || !t.products.length) return;
        const n = ++De,
          o = (await Promise.all(t.products.map(H))).filter(
            (i) => i && i.live && D(i).length,
          );
        if (n !== De || a.brand !== e || a.model !== t) return;
        const r = {
          label: "Compatible with your " + e.name + " " + t.name,
          family: Ft(e, t),
          brandId: e.id || e.slug || "",
          modelId: t.id || "",
          modelName: t.name,
          machineSelection: !0,
          screenCompatibility: t.screenCompatibility !== !1,
          snapshot: f.publication
            ? {
                version: f.publication.version,
                checksum: f.publication.checksum,
                targetThemeId: f.publication.targetThemeId,
              }
            : null,
          products: o.map((i) => {
            const d = D(i),
              c = (t.assignments && t.assignments[i.id]) || {};
            return {
              id: i.id,
              recommendationId: i.id,
              productId: i.live.id,
              handle: i.live.handle || i.handle,
              title: i.name || i.live.title,
              image: z(i, d[0]) || W(i, d[0]),
              cutout: z(i, d[0]) || "",
              preferredVariantMatch: i.preferredVariantMatch || "",
              role: c.role || "compatible",
              defaultVariantId: c.defaultVariantId || "",
              allowedVariantIds: c.allowedVariantIds || [],
              currency: i.live.currency || ce,
              variants: d.map((b) => ({
                id: b.id,
                title: b.title,
                price: b.price,
                image: z(i, b) || W(i, b),
                available: !!b.available,
              })),
            };
          }),
        };
        ((window.PesadoCartRecommendationContext = r),
          window.PesadoCartCompanion &&
            typeof window.PesadoCartCompanion.setContext == "function" &&
            window.PesadoCartCompanion.setContext(r),
          document.dispatchEvent(
            new CustomEvent("pesado:cart-recommendations", { detail: r }),
          ));
      }
      function J(e, t) {
        const n = z(e) || W(e);
        return n
          ? '<img src="' +
              l(n) +
              '&width=480" alt="' +
              l(e.name) +
              '" loading="lazy">'
          : '<span class="pcg__placeholder ' +
              (t || "") +
              '">' +
              Ie +
              "</span>";
      }
      function Lt(e) {
        const t = !e.variant,
          n = D(e).length > 1,
          o = !!(e.live || e.loadError),
          r = U(e).length ? "Out of stock" : "Unavailable",
          i = e.loadError
            ? "View product"
            : o
              ? t
                ? r
                : n
                  ? "Choose options"
                  : "Add to cart"
              : "Loading\u2026",
          d = e.loadError
            ? "open-product-page"
            : n
              ? "open-product"
              : "add-product";
        return (
          '<article class="pcg__product" data-product-id="' +
          e.id +
          '"><button type="button" class="pcg__product-media" data-action="open-product" data-product="' +
          e.id +
          '">' +
          J(e) +
          '</button><div><button type="button" class="pcg__product-name" data-action="open-product" data-product="' +
          e.id +
          '">' +
          l(e.name) +
          '</button><div class="pcg__product-meta">' +
          l(e.spec) +
          '</div><div class="pcg__product-price">' +
          Ye(e) +
          "</div>" +
          (e.videoId
            ? '<button type="button" class="pcg__video-link" data-action="open-video" data-product="' +
              e.id +
              '">\u25B6 Watch video</button>'
            : "") +
          '</div><button type="button" class="pcg__button" data-action="' +
          d +
          '" data-product="' +
          e.id +
          '" ' +
          (t && !e.loadError ? "disabled" : "") +
          ">" +
          i +
          "</button></article>"
        );
      }
      function At(e) {
        if (e && e.managerOrdered)
          return (e.products || []).reduce((n, o) => {
            const r = f.products[o],
              i = e.assignments && e.assignments[o];
            if (!r || (i && i.role === "upgrade")) return n;
            const d = n[n.length - 1];
            return (
              d && d.cat === r.cat
                ? d.items.push(r)
                : n.push({ cat: r.cat, items: [r] }),
              n
            );
          }, []);
        const t = {};
        return (
          (e.products || []).forEach((n) => {
            const o = f.products[n];
            o && (t[o.cat] || (t[o.cat] = []), t[o.cat].push(o));
          }),
          f.categoryOrder
            .filter((n) => t[n])
            .map((n) => ({ cat: n, items: t[n] }))
        );
      }
      function Xe(e) {
        return !e || !e.assignmentList
          ? []
          : e.assignmentList
              .filter((t) => t.role === "kit" && f.products[t.productId])
              .map((t) => t.productId);
      }
      function Ft(e, t) {
        return t && t.familyId ? t.familyId : "";
      }
      function Z(e, t) {
        return !t || !t.assignmentList
          ? []
          : t.assignmentList
              .filter((n) => n.role === "upgrade" && f.products[n.productId])
              .map((n) => n.productId);
      }
      function Nt(e) {
        const t = a.brand,
          n = a.model;
        if (!t || !n) return "";
        const o = At(n),
          r = Xe(n)
            .map((y) => f.products[y])
            .filter(Boolean),
          i = r.length >= 2 && r.every((y) => y.variant),
          d = r.some((y) => !y.live && !y.loadError),
          c = !d && !i,
          b = i
            ? r.reduce((y, I) => y + Number(I.variant.price || 0), 0)
            : null,
          S = i ? P(b) : d ? "Loading\u2026" : "Out of stock",
          w = c ? "Out of stock" : d ? "Loading\u2026" : "Add complete kit",
          k = Z(t, n),
          F = t.models
            .map((y, I) => {
              const ke = y === n,
                ne = !y.products || !y.products.length;
              return (
                '<button type="button" class="pcg__model' +
                (ke ? " is-active" : "") +
                '" data-action="select-model" data-model="' +
                I +
                '" ' +
                (ne ? "disabled" : "") +
                ">" +
                l(y.name) +
                (ne ? " \xB7 n/a" : "") +
                "</button>"
              );
            })
            .join("");
        let p = "";
        pt &&
          r.length >= 2 &&
          (p =
            '<section class="pcg__bundle"><span class="pcg__bundle-label">\u2605 Complete kit</span><div><h3>The ' +
            l(t.name) +
            " essentials</h3><p>" +
            r.map((y) => l(y.name)).join(" + ") +
            '</p></div><div class="pcg__bundle-actions">' +
            ft(b, S) +
            '<button type="button" class="pcg__button" data-action="add-bundle" ' +
            (i ? "" : "disabled") +
            ">" +
            w +
            "</button></div></section>");
        let R =
          '<div class="pcg__empty"><strong>No tested products for this model yet.</strong></div>';
        o.length &&
          (R = o
            .map(
              (y) =>
                '<section class="pcg__category"><h3 class="pcg__category-title">' +
                l(f.categoryLabels[y.cat]) +
                " \xB7 " +
                y.items.length +
                "</h3>" +
                y.items.map(Lt).join("") +
                "</section>",
            )
            .join(""));
        let ae = "";
        ut &&
          k.length &&
          (ae =
            '<section class="pcg__cross-sell"><h3>Recommended for your ' +
            l(t.name) +
            '</h3><p>Compatible additions for your selected machine.</p><div class="pcg__cross-grid">' +
            k
              .map((y) => {
                const I = f.products[y];
                return (
                  '<button type="button" class="pcg__cross-card" data-action="open-product" data-product="' +
                  y +
                  '">' +
                  J(I) +
                  "<span><strong>" +
                  l(I.name) +
                  "</strong><span>" +
                  Ye(I) +
                  "</span></span></button>"
                );
              })
              .join("") +
            "</div></section>");
        const Se = n.compatibilityNotice
          ? '<aside class="pcg__compatibility-notice" role="status"><strong>Shower screen compatibility</strong><p>' +
            l(n.compatibilityNotice) +
            "</p></aside>"
          : "";
        return (
          '<button type="button" class="pcg__scrim" data-action="close-brand" aria-label="Close compatibility drawer"></button><aside class="pcg__drawer' +
          (e ? " pcg__drawer--stable" : "") +
          '" role="dialog" aria-modal="true" aria-labelledby="pcg-brand-title"' +
          (a.product ? ' inert aria-hidden="true"' : "") +
          '><header class="pcg__drawer-head"><div><p class="pcg__drawer-kicker">' +
          (t.tier === "pro" ? "Commercial" : "Domestic") +
          " \xB7 " +
          t.models.length +
          ' models</p><h2 class="pcg__drawer-title" id="pcg-brand-title">' +
          l(t.name) +
          '</h2></div><button type="button" class="pcg__close" data-action="close-brand" aria-label="Close">' +
          j +
          '</button></header><div class="pcg__models"><details class="pcg__models-disclosure"><summary><span class="pcg__models-current"><small>Selected model</small><strong>' +
          l(n.name) +
          '</strong></span><span class="pcg__models-change" aria-hidden="true"></span></summary><div class="pcg__models-panel"><p class="pcg__drawer-kicker">Select your model</p><div class="pcg__models-list">' +
          F +
          '</div></div></details></div><div class="pcg__drawer-layout"><div class="pcg__drawer-body" data-pcg-drawer-body>' +
          Se +
          p +
          R +
          ae +
          "</div></div></aside>"
        );
      }
      function ve(e) {
        return (
          {
            black:
              "radial-gradient(circle at 32% 28%, #5f5f5f 0 7%, #202020 34%, #050505 100%)",
            bronze:
              "linear-gradient(135deg, #2c1b13 0%, #a66d3c 44%, #d3a06a 55%, #55301d 100%)",
            gold: "linear-gradient(135deg, #5f4100 0%, #d6a719 42%, #f0cf5c 55%, #876100 100%)",
            silver:
              "linear-gradient(135deg, #777 0%, #f6f6f6 42%, #bcbcbc 62%, #696969 100%)",
            iris: "linear-gradient(135deg, #4b74c8 0%, #963e91 30%, #e07b63 57%, #54a8a4 82%, #493f75 100%)",
            riga: "repeating-linear-gradient(135deg, #231411 0 4px, #884732 4px 8px, #d99172 8px 11px, #5b2b21 11px 15px)",
            dusk: "linear-gradient(135deg, #182027 0%, #526470 47%, #26313a 100%)",
            haze: "linear-gradient(135deg, #5f5954 0%, #bbb0a6 47%, #766e67 100%)",
            white:
              "linear-gradient(135deg, #fff 0%, #f0f0f0 48%, #cfcfcf 100%)",
            oak: "repeating-linear-gradient(105deg, #5c351d 0 3px, #be8548 3px 8px, #e1b779 8px 11px, #7b4a28 11px 15px)",
            raya: "repeating-linear-gradient(125deg, #2c1812 0 4px, #8d5135 4px 8px, #d59467 8px 11px, #4e271c 11px 15px)",
            "full black":
              "radial-gradient(circle at 32% 28%, #5f5f5f 0 7%, #202020 34%, #050505 100%)",
            "full white":
              "linear-gradient(135deg, #fff 0%, #f0f0f0 48%, #cfcfcf 100%)",
          }[m(e)] || "linear-gradient(135deg, #b5b0ab, #69645f)"
        );
      }
      function ee(e) {
        return e.filter(
          (t, n, o) => t && o.findIndex((r) => m(r) === m(t)) === n,
        );
      }
      function qt(e) {
        const t = e.map((p) => A(L(p))),
          n = t.filter((p) => p.mode === "MODULAR"),
          o = t.filter((p) => p.mode === "ONE-PIECE"),
          r = ee(n.map((p) => p.body)),
          i = ee(n.filter((p) => m(p.body) === m(a.pdpBody)).map((p) => p.end)),
          d = ee(o.map((p) => p.full)),
          c = [];
        (n.length && c.push("MODULAR"), o.length && c.push("ONE-PIECE"));
        const b = Ke(a.product),
          S = ["SPOUTED", "NAKED", "HYBRID"]
            .map((p) => {
              const R =
                a.pdpBaseStatus[p] || (b[p] ? "loading" : "unavailable");
              return (
                '<button type="button" data-action="pdp-base" data-base="' +
                p +
                '" class="' +
                (a.pdpBase === p ? "is-selected" : "") +
                '" ' +
                (R === "ready" ? "" : "disabled") +
                ">" +
                p +
                "</button>"
              );
            })
            .join(""),
          w = c
            .map(
              (p) =>
                '<button type="button" data-action="pdp-mode" data-mode="' +
                p +
                '" class="' +
                (a.pdpMode === p ? "is-selected" : "") +
                '">' +
                p +
                "</button>",
            )
            .join(""),
          k =
            a.pdpMode === "ONE-PIECE"
              ? a.pdpFull
              : a.pdpBody + " body / " + a.pdpEnd + " end";
        let F = "";
        return (
          a.pdpMode === "ONE-PIECE"
            ? (F =
                '<div class="pcg__pdp-fulls"><span class="pcg__pdp-option-label">One-piece handle</span><div>' +
                d
                  .map(
                    (p) =>
                      '<button type="button" data-action="pdp-full" data-full="' +
                      l(p) +
                      '" class="' +
                      (m(a.pdpFull) === m(p) ? "is-selected" : "") +
                      '"><i style="--pcg-swatch:' +
                      ve(p) +
                      '"></i><span>' +
                      l(p) +
                      "</span></button>",
                  )
                  .join("") +
                "</div></div>")
            : (F =
                '<div class="pcg__pdp-swatches"><div><span class="pcg__pdp-option-label">Body</span><div>' +
                r
                  .map(
                    (p) =>
                      '<button type="button" data-action="pdp-body" data-body="' +
                      l(p) +
                      '" title="' +
                      l(p) +
                      '" class="' +
                      (m(a.pdpBody) === m(p) ? "is-selected" : "") +
                      '" style="--pcg-swatch:' +
                      ve(p) +
                      '"><span class="visually-hidden">' +
                      l(p) +
                      "</span></button>",
                  )
                  .join("") +
                '</div></div><div><span class="pcg__pdp-option-label">End</span><div>' +
                i
                  .map(
                    (p) =>
                      '<button type="button" data-action="pdp-end" data-end="' +
                      l(p) +
                      '" title="' +
                      l(p) +
                      '" class="' +
                      (m(a.pdpEnd) === m(p) ? "is-selected" : "") +
                      '" style="--pcg-swatch:' +
                      ve(p) +
                      '"><span class="visually-hidden">' +
                      l(p) +
                      "</span></button>",
                  )
                  .join("") +
                "</div></div></div>"),
          '<div class="pcg__pdp-variant-model"><div class="pcg__pdp-option-label">Base</div><div class="pcg__pdp-segments">' +
            S +
            '</div><div class="pcg__pdp-handle-head"><span>Handle \u2014 <b>' +
            l(k) +
            "</b></span><small>" +
            (a.pdpMode === "ONE-PIECE"
              ? d.length + " finishes"
              : n.length + " combinations") +
            '</small></div><div class="pcg__pdp-segments pcg__pdp-segments--handle">' +
            w +
            '</div><div class="pcg__pdp-choice-stage">' +
            F +
            "</div></div>"
        );
      }
      function Tt(e, t, n) {
        return !e || t.length < 2 || !e.options
          ? ""
          : '<div class="pcg__variant-selectors">' +
              e.options
                .map((o, r) => {
                  const i = typeof o == "string" ? o : o.name,
                    d = ee(t.map((b) => b.options[r]).filter(Boolean));
                  if (d.length < 2) return "";
                  const c = a.pdpSelections[r] || (n && n.options[r]) || d[0];
                  return (
                    "<label><span>" +
                    l(i || "Option " + (r + 1)) +
                    '</span><select data-pcg-option="' +
                    r +
                    '">' +
                    d
                      .map(
                        (b) =>
                          '<option value="' +
                          l(b) +
                          '"' +
                          (b === c ? " selected" : "") +
                          ">" +
                          l(b) +
                          "</option>",
                      )
                      .join("") +
                    "</select></label>"
                  );
                })
                .join("") +
              "</div>";
      }
      function Ot(e) {
        return T(e)
          ? a.pdpBase === "HYBRID"
            ? { id: "vjKbMgLaXmY", start: 4 }
            : { id: "07Gop_v8ddI", start: 0 }
          : e && e.videoId
            ? { id: e.videoId, start: 0 }
            : null;
      }
      function pfShippingIcon(type) {
        const paths = {
          truck: 'M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
          pin: 'M12 21s6-5.1 6-12a6 6 0 1 0-12 0c0 6.9 6 12 6 12Zm0-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
          shield: 'm12 2 8 3v6c0 5.1-3.4 9.2-8 11-4.6-1.8-8-5.9-8-11V5l8-3Zm-1 13 5-5-1.4-1.4L11 12.2 9.4 10.6 8 12l3 3Z',
          arrow: 'M5 19 19 5m-8 0h8v8'
        };
        return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + paths[type] + '"></path></svg>';
      }
      function pfShippingFooter(product, variant, available) {
        const node = document.querySelector('#pesado-configurator-shipping [data-pesado-shipping-context]');
        const market = node ? node.dataset : {};
        const country = String(market.country || '').toLowerCase();
        const total = variant ? Number(variant.price || 0) * a.pdpQty : null;
        const threshold = Number(market.minimumCents || Number(market.threshold || 0) * 100);
        const enabled = market.freeShippingEnabled === 'true' && threshold > 0;
        const title = enabled ? 'Free shipping to ' + market.market + ' on orders over ' + market.thresholdMoney : 'Shipping options';
        const status = !enabled ? 'Shown at checkout' : total == null ? 'Select an available configuration' : total >= threshold ? 'This configuration qualifies for free shipping' : 'Add ' + P(threshold - total, market.currency) + ' for free shipping';
        const flag = /^[a-z]{2}$/.test(country) ? '<img src="https://cdn.shopify.com/static/images/flags/' + country + '.svg" width="24" height="18" alt="' + l(market.market || market.country) + ' flag">' : '';
        const duty = market.dutiesIncluded === 'true' ? 'Duties &amp; taxes included' : country === 'dk' ? 'Duties &amp; taxes not included' : '';
        return '<footer class="pcg-pf-shipping"><div class="pcg-pf-shipping__bar"><div class="pcg-pf-shipping__summary">' + flag + '<p><strong>' + l(title) + '</strong>' + (duty ? '<b>' + duty + '</b>' : '') + '<span>' + l(status) + '</span></p></div>' +
          '<div class="pcg__pdp-action-qty"><button type="button" data-action="pdp-minus" aria-label="Decrease quantity">−</button><span>' + a.pdpQty + '</span><button type="button" data-action="pdp-plus" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="pcg__pdp-add" data-action="add-pdp" data-product="' + l(product.id) + '" ' + (available ? '' : 'disabled') + '><span>Add to cart</span><strong>' + l(total == null ? 'Unavailable' : P(total, market.currency)) + '</strong></button></div>' +
          '<div class="pcg-pf-shipping__trust"><div>' + pfShippingIcon('shield') + '<p><strong>Quality checked</strong><span>Every unit inspected by hand</span></p></div><div>' + pfShippingIcon('pin') + '<p><strong>' + (country === 'kr' ? 'Korea dispatch' : 'Gold Coast dispatch') + '</strong><span>' + (country === 'kr' ? 'Shipped from Korea' : 'Shipped from QLD, Australia') + '</span></p></div>' +
          '<button type="button" data-action="pdp-shipping" aria-expanded="' + !!a.pdpShippingOpen + '" aria-controls="pcg-pf-shipping-panel">' + pfShippingIcon('arrow') + '<p><strong>Shipping &amp; returns</strong><span>' + (a.pdpShippingOpen ? 'Back to product' : 'Open details') + '</span></p></button></div>' +
          '<span class="pcg-pf-shipping__error" role="status" aria-live="polite">' + l(a.pdpError) + '</span></footer>';
      }
      function pfShippingPanel() {
        const content = document.querySelector('#pesado-configurator-shipping [data-pcg-shipping-content]');
        return '<section class="pcg-pf-shipping__panel" id="pcg-pf-shipping-panel"><button type="button" data-action="pdp-shipping">← Back to product</button>' + (content ? content.innerHTML : '<p>Shipping details are available at checkout.</p>') + '</section>';
      }
      function Vt() {
        const e = a.product;
        if (!e) return "";
        const t = O(),
          n = a.pdpVariant,
          o = Q(!1),
          r = !!(n && n.available),
          i = $e(e, t),
          d = Math.min(a.pdpMediaIndex, Math.max(0, i.length - 1)),
          c = i[d] || "",
          b = xt(e, n),
          S = Pt(e, n),
          w = T(e),
          k = w
            ? "Modular Portafilter"
            : e.name || (t && t.title) || "Pesado tool",
          F = w
            ? "One body, three bases. Choose the exact setup and finish for your machine."
            : it(
                (t && t.description) ||
                  "Select the exact option for your machine.",
              ),
          p = Ot(e),
          R = w ? "304 stainless" : f.categoryLabels[e.cat] || "Pesado tool",
          ae = n && Number(n.weight) > 0 ? Number(n.weight) + " g" : "\u2014",
          Se = n && n.sku ? n.sku : "SELECT OPTION",
          y =
            a.pdpFitLabel ||
            (a.brand && a.model
              ? [a.brand.name, a.model.name].filter(Boolean).join(" ")
              : ""),
          I = y
            ? '<div class="pcg__pdp-fit"><span><i>\u2713</i>Fits your ' +
              l(y) +
              " \xB7 " +
              l(b) +
              '</span><button type="button" data-action="close-product" aria-label="Close product">' +
              j +
              "</button></div>"
            : "",
          ke = I
            ? ""
            : '<button type="button" class="pcg__pdp-close" data-action="close-product" aria-label="Close product">' +
              j +
              "</button>",
          ne = i
            .slice(0, 3)
            .map(
              (Zt, Ce) =>
                '<button type="button" data-action="pdp-media" data-index="' +
                Ce +
                '" class="' +
                (d === Ce ? "is-selected" : "") +
                '" aria-label="View product image ' +
                (Ce + 1) +
                '"><img src="' +
                l(ge(Zt, 220)) +
                '" alt=""></button>',
            )
            .join(""),
          Yt =
            i.length > 3
              ? '<button type="button" class="pcg__pdp-more" data-action="pdp-media-next" aria-label="View more product images"><strong>+' +
                (i.length - 3) +
                "</strong><span>Images</span></button>"
              : "",
          Kt = w ? qt(o) : Tt(t, o, n),
          Gt = w
            ? a.pdpBase.charAt(0) + a.pdpBase.slice(1).toLowerCase()
            : (n && n.title) || "Selected option",
          $t = w
            ? a.pdpMode === "ONE-PIECE"
              ? a.pdpFull
              : a.pdpBody + " body / " + a.pdpEnd + " end"
            : (n && n.title) || "",
          Wt = w ? Bt(o, n) : "",
          Xt = z(e, n) || "",
          rt = c ? '<img src="' + l(ge(c, 600)) + '" alt="">' : J(e),
          Jt = w
            ? '<button type="button" class="pcg__pdp-mobile-preview' +
              (a.pdpPreviewHintActive ? " is-zoom-hint" : "") +
              '" data-action="pdp-preview-zoom" data-pcg-current-image="' +
              l(c) +
              '" data-pcg-cutout="' +
              l(Xt) +
              '" data-pcg-mask-image="' +
              l(Wt) +
              '" aria-label="View selected portafilter larger">' +
              rt +
              '<span><b>Live preview</b><small class="pcg__pdp-preview-action">Tap to zoom</small><em class="pcg__pdp-preview-variant">' +
              l($t) +
              "</em></span></button>"
            : '<div class="pcg__pdp-mobile-preview" aria-hidden="true">' +
              rt +
              "<span><b>Live preview</b></span></div>";
        return (
          '<button type="button" class="pcg__scrim pcg__pdp-scrim" data-action="close-product" aria-label="Close product"></button><article class="pcg__pdp pcg__pdp--2a' + (w ? ' pcg__pdp--shipping' : '') + '" role="dialog" aria-modal="true" aria-labelledby="pcg-pdp-title">' +
          I +
          ke +
          (w && a.pdpShippingOpen ? '<h2 id="pcg-pdp-title" class="visually-hidden">Shipping &amp; returns</h2>' + pfShippingPanel() : '<div class="pcg__pdp-grid"><div class="pcg__pdp-media"><div class="pcg__pdp-hero">' +
          (c ? '<img src="' + l(ge(c, 900)) + '" alt="' + l(k) + '">' : J(e)) +
          '</div><div class="pcg__pdp-thumbs">' +
          ne +
          Yt +
          '</div></div><div class="pcg__pdp-content">' +
          Jt +
          '<p class="pcg__pdp-kicker">Pesado 58.5 \xB7 ' +
          l(Se) +
          '</p><h2 id="pcg-pdp-title">' +
          l(k) +
          '</h2><p class="pcg__pdp-description">' +
          l(F) +
          '</p><div class="pcg__pdp-rule pcg__pdp-rule--strong"></div><div class="pcg__pdp-specs"><div><span>Fits</span><strong>' +
          l(S) +
          "</strong></div><div><span>Size</span><strong>" +
          l(b) +
          "</strong></div><div><span>Body</span><strong>" +
          l(R) +
          "</strong></div><div><span>Weight</span><strong>" +
          l(ae) +
          '</strong></div></div><div class="pcg__pdp-rule"></div>' +
          Kt +
          '<div class="pcg__pdp-links">' +
          (p
            ? '<button type="button" data-action="open-video" data-product="' +
              e.id +
              '" data-video-id="' +
              p.id +
              '" data-video-start="' +
              p.start +
              '"><i></i>Install video</button>'
            : "") +
          '<a href="' +
          l(Mt(e)) +
          '">Full product \u2192</a></div></div></div>') +
          (w ? pfShippingFooter(e, n, r) : '<div class="pcg__pdp-actionbar"><div class="pcg__pdp-action-price"><strong>' +
          P(n ? n.price : Qe(e)) +
          "</strong><span>" +
          l(Gt) +
          " \xB7 " +
          (r ? "in stock" : "unavailable") +
          '</span></div><div class="pcg__pdp-action-qty"><button type="button" data-action="pdp-minus" aria-label="Decrease quantity">\u2212</button><span>' +
          a.pdpQty +
          '</span><button type="button" data-action="pdp-plus" aria-label="Increase quantity">+</button></div><button type="button" class="pcg__pdp-add" data-action="add-pdp" data-product="' +
          e.id +
          '" ' +
          (r ? "" : "disabled") +
          '>Add to cart</button><span class="pcg__pdp-error" role="status" aria-live="polite">' +
          l(a.pdpError) +
          "</span></div>") + "</article>"
        );
      }
      function Rt() {
        const e = a.video;
        if (!e || !e.videoId) return "";
        const t =
          "https://www.youtube-nocookie.com/embed/" +
          encodeURIComponent(e.videoId) +
          "?autoplay=1&rel=0" +
          (e.videoStart ? "&start=" + Number(e.videoStart) : "");
        return (
          '<button type="button" class="pcg__scrim" style="z-index:99994;background:rgba(10,8,4,.86)" data-action="close-video" aria-label="Close video"></button><section class="pcg__video" role="dialog" aria-modal="true" aria-labelledby="pcg-video-title"><button type="button" class="pcg__close" data-action="close-video" aria-label="Close">' +
          j +
          '</button><h2 class="visually-hidden" id="pcg-video-title">Video: ' +
          l(e.name) +
          '</h2><div class="pcg__video-stage"><iframe src="' +
          t +
          '" title="Video: ' +
          l(e.name) +
          '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div><div class="pcg__video-foot"><span>' +
          l(e.name) +
          "</span>" +
          (Re
            ? '<a href="' + l(Re) + '">Open HD directory \u2192</a>'
            : "<span>Pesado workshop</span>") +
          "</div></section>"
        );
      }
      function jt() {
        if (!a.noResultsQuery) return "";
        const e = s.dataset.machineExpress || s.dataset.machineBambino || "",
          t = a.noResultsFormOpen,
          n = t && Ne ? Ne.innerHTML : "",
          o = t
            ? "Send us your machine details. Our technical team will confirm compatibility and let you know if we\u2019re currently developing new options for your machine."
            : "Email us at hello@pesado.com.au with your machine brand and model. Our technical team will confirm compatibility and let you know if we\u2019re currently developing new options for your machine.";
        return (
          '<button type="button" class="pcg__scrim" style="z-index:99992" data-action="close-no-results" aria-label="Close compatibility help"></button><section class="pcg__no-results' +
          (t ? " is-form-open" : "") +
          '" role="dialog" aria-modal="true" aria-labelledby="pcg-no-results-title"><button type="button" class="pcg__close" data-action="close-no-results" aria-label="Close">' +
          j +
          '</button><div class="pcg__no-results-media">' +
          (e
            ? '<img src="' +
              l(e) +
              '" alt="Pesado compatible espresso machine">'
            : Ie) +
          '</div><div class="pcg__no-results-content"><p class="pcg__pdp-kicker">Compatibility help</p><h2 id="pcg-no-results-title">Oops \u2014 we couldn\u2019t find your machine.</h2><p>' +
          o +
          "</p>" +
          n +
          '<div class="pcg__no-results-actions">' +
          (t
            ? ""
            : '<button type="button" class="pcg__button pcg__button--accent" data-action="open-no-results-form">Send to our technical team</button>') +
          '<button type="button" class="pcg__button pcg__button--outline" data-action="browse-all-machines">Browse all machines</button></div></div></section>'
        );
      }
      function h(e) {
        const t = _.querySelector("[data-pcg-drawer-body]"),
          n = t ? t.scrollTop : 0,
          o = _.querySelector(".pcg__pdp-grid"),
          r = o ? o.scrollTop : 0;
        _.innerHTML =
          (!q && a.brand ? Nt(!!(e && e.stable)) : "") +
          (a.product ? Vt() : "") +
          (a.video ? Rt() : "") +
          (a.noResultsQuery ? jt() : "");
        const i = _.querySelector("[data-pcg-no-results-query]"),
          d = _.querySelector("[data-pcg-no-results-body]");
        (i && (i.value = a.noResultsQuery || ""),
          d &&
            (d.value = `Hi Pesado technical team,

I couldn\u2019t find my machine in the Compatibility Guide.

Please confirm compatibility and let me know if you\u2019re currently developing new options for this machine.`));
        const c = _.querySelector("[data-pcg-drawer-body]");
        c && e && e.preserveScroll && (c.scrollTop = n);
        const b = _.querySelector(".pcg__pdp-grid");
        b && e && e.preservePdpScroll && (b.scrollTop = r);
        const S = !!(
          (!q && a.brand) ||
          a.product ||
          a.video ||
          a.noResultsQuery
        );
        if (
          (document.documentElement.classList.toggle("pcg-overlay-open", S),
          document.documentElement.classList.toggle(
            "pcg-product-with-drawer",
            !!(!q && a.brand && a.product),
          ),
          (document.body.style.overflow = S ? "hidden" : ""),
          S && !(e && e.noFocus))
        ) {
          const w = _.querySelectorAll(".pcg__close"),
            k = w[w.length - 1];
          k && window.setTimeout(() => k.focus(), 0);
        }
      }
      function he(e, t) {
        const n = !!(
          t &&
          !a.pdpPreviewHintShown &&
          window.matchMedia("(max-width: 899px)").matches
        );
        if (
          (n && ((a.pdpPreviewHintShown = !0), (a.pdpPreviewHintActive = !0)),
          h(e),
          (a.pdpPreviewHintActive = !1),
          !n)
        )
          return;
        const o = _.querySelector(".pcg__pdp-mobile-preview.is-zoom-hint");
        o &&
          window.setTimeout(() => {
            o.isConnected && o.classList.remove("is-zoom-hint");
          }, 900);
      }
      function te(e) {
        (window.clearTimeout(a.toastTimer),
          (de.textContent = e),
          (de.hidden = !1),
          (a.toastTimer = window.setTimeout(() => {
            de.hidden = !0;
          }, 2300)));
      }
      async function ye() {
        try {
          const e = await fetch(ue("cart.js"), { credentials: "same-origin" });
          if (!e.ok) throw new Error("Unable to load cart");
          ((a.cart = await e.json()), we(a.cart));
        } catch (e) {
          ((a.cart = {
            item_count: 0,
            items: [],
            total_price: 0,
            items_subtotal_price: 0,
            currency: ce,
          }),
            we(a.cart));
        }
      }
      function we(e) {
        const t = Number(e && e.item_count) || 0;
        (document
          .querySelectorAll("[data-cart-count], [data-pesado-cart-count]")
          .forEach((n) => {
            n.textContent = t;
          }),
          document
            .querySelectorAll("[data-pesado-cart-item-label]")
            .forEach((n) => {
              n.textContent = t === 1 ? "item" : "items";
            }),
          Array.from(document.documentElement.classList).forEach((n) => {
            /^t4s-cart-count-\d+$/.test(n) &&
              document.documentElement.classList.remove(n);
          }),
          document.documentElement.classList.add("t4s-cart-count-" + t));
      }
      function Dt() {
        (we(a.cart),
          document.dispatchEvent(
            new CustomEvent("cart:updated", { detail: { cart: a.cart } }),
          ),
          document.dispatchEvent(
            new CustomEvent("cart:update:count", {
              detail: { cart: a.cart, item_count: a.cart.item_count },
            }),
          ));
      }
      function M() {
        return window.PesadoUpgradeAnalytics || null;
      }
      function Ut(e, t) {
        const n = M();
        return !n || typeof n.lineProperties != "function"
          ? e
          : e.map((o, r) =>
              Object.assign({}, o, {
                properties: Object.assign(
                  {},
                  o.properties || {},
                  n.lineProperties(t, {
                    machine: [a.brand && a.brand.name, a.model && a.model.name]
                      .filter(Boolean)
                      .join(" / "),
                    parentProduct: "compatibility-guide",
                    rank: r + 1,
                    reason:
                      t === "compatibility_complete_kit"
                        ? "complete_kit"
                        : "compatible_machine_result",
                  }),
                ),
              }),
            );
      }
      async function _e(e, t, n) {
        if (!e.length)
          return (te("No available variant was found for this selection."), !1);
        n && (n.disabled = !0);
        const o =
            e.length > 1 ? "compatibility_complete_kit" : "compatibility_guide",
          r = M(),
          i = Ut(e, o);
        r &&
          typeof r.track == "function" &&
          r.track("compatibility_add_click", {
            brand: a.brand && a.brand.name,
            machine: a.model && a.model.name,
            source: o,
            item_count: i.length,
            variant_ids: i.map((d) => d.id).join(","),
          });
        try {
          const d = await fetch(ue("cart/add.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items: i }),
          });
          if (!d.ok) {
            const c = await d.json().catch(() => ({}));
            throw new Error(c.description || "Unable to add this item");
          }
          return (
            n &&
              (n.classList.add("is-added"), (n.textContent = "\u2713 Added")),
            await ye(),
            r &&
              typeof r.ensureCartAttribution == "function" &&
              r.ensureCartAttribution(),
            r &&
              typeof r.track == "function" &&
              r.track("compatibility_add_success", {
                brand: a.brand && a.brand.name,
                machine: a.model && a.model.name,
                source: o,
                item_count: i.length,
                variant_ids: i.map((c) => c.id).join(","),
              }),
            Dt(),
            a.brand && a.model && (await X(a.brand, a.model)),
            a.product && ((a.product = null), h({ stable: !0, noFocus: !0 })),
            vt(),
            te(t),
            !0
          );
        } catch (d) {
          return (te(d.message || "Unable to add this item."), !1);
        } finally {
          n &&
            window.setTimeout(() => {
              n.disabled = !1;
            }, 900);
        }
      }
      async function Ht(e, t, n) {
        const o = await H(e);
        if (!o.variant) {
          (te("This exact option needs to be selected on the product page."),
            (window.location.href = K(o)));
          return;
        }
        await _e(
          [{ id: o.variant.id, quantity: t || 1 }],
          "Added \xB7 " + o.name,
          n,
        );
      }
      async function zt(e) {
        const t = Xe(a.model);
        await Promise.all(t.map(H));
        const n = t
          .map((o) => f.products[o])
          .filter((o) => o && o.variant)
          .map((o) => ({ id: o.variant.id, quantity: 1 }));
        await _e(n, "Complete kit added \xB7 " + n.length + " items", e);
      }
      function Qt() {
        const e = !!(a.product && !a.video);
        if (a.noResultsQuery)
          ((a.noResultsQuery = ""), (a.noResultsFormOpen = !1));
        else if (a.video) a.video = null;
        else if (a.product) a.product = null;
        else if (a.brand) ((a.brand = null), (a.model = null));
        else return;
        (h({ stable: !0, noFocus: e }),
          e
            ? Ze()
            : !a.brand &&
              !a.product &&
              !a.video &&
              !a.noResultsQuery &&
              a.lastFocus &&
              a.lastFocus.focus({ preventScroll: !0 }));
      }
      function Je(e, t) {
        x(t || null);
      }
      function Ze() {
        const e = a.productFocus;
        let t = null;
        (e &&
          e.productId &&
          (t =
            Array.from(
              _.querySelectorAll(
                '[data-action="open-product"][data-product="' +
                  e.productId +
                  '"]',
              ),
            ).find((n) => n.className === e.className) || null),
          !t &&
            a.lastFocus &&
            document.documentElement.contains(a.lastFocus) &&
            (t = a.lastFocus),
          t && ((a.lastFocus = t), t.focus({ preventScroll: !0 })));
      }
      function et(e, t, n) {
        e &&
          (t &&
            ((a.lastFocus = t),
            (a.productFocus = { productId: e.id, className: t.className })),
          (a.product = e),
          (a.pdpQty = 1),
          (a.pdpShippingOpen = false),
          (a.pdpError = ""),
          (a.pdpFitLabel = n && n.fitLabel ? n.fitLabel : ""),
          (a.pdpPreviewHintShown = !1),
          (a.pdpPreviewHintActive = !1),
          q &&
            n &&
            n.modelName &&
            (a.model = { name: n.modelName, size: n.size || "" }),
          (a.pdpBase = Ge(e.handle)),
          (a.pdpBaseProducts = {}),
          (a.pdpBaseStatus = {}),
          e.live &&
            ((a.pdpBaseProducts[a.pdpBase] = e.live),
            (a.pdpBaseStatus[a.pdpBase] = "ready")),
          Je(e, e.variant),
          h({ stable: !0 }),
          H(e.id).then(() => {
            a.product === e &&
              ((a.pdpBaseProducts[a.pdpBase] = e.live),
              (a.pdpBaseStatus[a.pdpBase] = e.variant
                ? "ready"
                : "unavailable"),
              Je(e, e.variant),
              h({ noFocus: !0, stable: !0 }),
              It(e));
          }));
      }
      (s.addEventListener("click", async (e) => {
        const t = e.target.closest("[data-action]");
        if (!t || !s.contains(t)) return;
        const n = t.dataset.action;
        if (n === "open-brand") {
          const o = f.brands.find((i) => i.slug === t.dataset.brand);
          if (!o) return;
          ((a.lastFocus = t),
            (a.brand = o),
            (a.model = o.models.find((i) => i.products.length) || o.models[0]),
            M() &&
              M().track("compatibility_brand_open", {
                brand: o.name,
                model: a.model && a.model.name,
              }),
            h(),
            X(o, a.model));
          const r = [].concat(a.model.products, Z(o, a.model));
          $(r, () => {
            a.brand === o && h({ preserveScroll: !0, noFocus: !0, stable: !0 });
          });
        } else if (n === "select-v3-brand") {
          const o = f.brands.find((i) => i.slug === t.dataset.brand);
          if (!o) return;
          ((a.v3Brand = o), B());
          const r = s.querySelector("[data-pcg-v3-model-wrap]");
          r && r.scrollIntoView({ behavior: "smooth", block: "center" });
        } else if (n === "open-v3-model") {
          const o = f.brands.find((d) => d.slug === t.dataset.brand),
            r = o && o.models[Number(t.dataset.model)];
          if (!o || !r || !r.products || !r.products.length) return;
          ((a.lastFocus = t),
            (a.brand = o),
            (a.model = r),
            M() &&
              M().track("compatibility_model_select", {
                brand: o.name,
                model: r.name,
                machine: r.name,
              }),
            h(),
            X(o, r));
          const i = [].concat(r.products, Z(o, r));
          $(i, () => {
            a.brand === o &&
              a.model === r &&
              h({ preserveScroll: !0, noFocus: !0, stable: !0 });
          });
        } else if (n === "v3-path") {
          const o = t.dataset.pcgPath,
            r = f.brands.find((d) => d.slug === "breville");
          (s
            .querySelectorAll('[data-action="v3-path"]')
            .forEach((d) => d.classList.toggle("is-selected", d === t)),
            (a.query = ""),
            (v.value = ""),
            (a.v3Letter = "all"),
            o === "breville" && r
              ? ((a.tier = "home"), (a.v3Brand = r))
              : o === "commercial"
                ? ((a.tier = "pro"), (a.v3Brand = null))
                : ((a.tier = "home"), (a.v3Brand = null)),
            B());
          const i =
            o === "breville"
              ? s.querySelector("[data-pcg-v3-model-wrap]")
              : s.querySelector("[data-pcg-v3-browse]");
          i &&
            i.scrollIntoView({
              behavior: "smooth",
              block: o === "breville" ? "center" : "start",
            });
        } else if (n === "v3-letter")
          ((a.v3Letter = t.dataset.letter || "all"), (a.v3Brand = null), B());
        else if (n === "select-model") {
          ((a.model = a.brand.models[Number(t.dataset.model)]),
            M() &&
              M().track("compatibility_model_select", {
                brand: a.brand.name,
                model: a.model && a.model.name,
                machine: a.model && a.model.name,
              }),
            h({ noFocus: !0, stable: !0 }),
            X(a.brand, a.model));
          const o = [].concat(a.model.products, Z(a.brand, a.model));
          $(o, () => h({ preserveScroll: !0, noFocus: !0, stable: !0 }));
        } else if (n === "close-brand")
          ((a.brand = null),
            (a.model = null),
            (a.product = null),
            h({ stable: !0 }));
        else if (n === "open-product") {
          const o = f.products[t.dataset.product];
          if (!o) return;
          et(o, t);
        } else if (n === "close-product")
          ((a.product = null), h({ stable: !0, noFocus: !0 }), Ze());
        else if (n === "open-product-page")
          window.location.href = K(f.products[t.dataset.product]);
        else if (n === "add-product") await Ht(t.dataset.product, 1, t);
        else if (n === "add-bundle") await zt(t);
        else if (n === "pdp-shipping") {
          a.pdpShippingOpen = !a.pdpShippingOpen;
          h({ noFocus: !0, stable: !0 });
          const control = _.querySelector(a.pdpShippingOpen ? '.pcg-pf-shipping__panel button' : '.pcg-pf-shipping__trust button');
          if (control) control.focus({ preventScroll: true });
        }
        else if (n === "pdp-minus")
          ((a.pdpQty = Math.max(1, a.pdpQty - 1)),
            h({ noFocus: !0, stable: !0 }));
        else if (n === "pdp-plus")
          ((a.pdpQty = Math.min(99, a.pdpQty + 1)),
            h({ noFocus: !0, stable: !0 }));
        else if (n === "pdp-media")
          (We(Number(t.dataset.index) || 0), h({ noFocus: !0, stable: !0 }));
        else if (n === "pdp-media-next") {
          const o = $e(a.product, O()),
            r = o.length
              ? a.pdpMediaIndex < 3
                ? Math.min(3, o.length - 1)
                : (a.pdpMediaIndex + 1) % o.length
              : 0;
          (We(r), h({ noFocus: !0, stable: !0 }));
        } else if (n === "pdp-preview-zoom") {
          if (!window.matchMedia("(max-width: 899px)").matches) return;
          document.dispatchEvent(
            new CustomEvent("pesado:product-spotlight", {
              detail: {
                trigger: t,
                currentImage: t.dataset.pcgCurrentImage || "",
                cutout: t.dataset.pcgCutout || "",
                maskImage: t.dataset.pcgMaskImage || "",
                keepLargestComponent: a.pdpBase !== "HYBRID",
              },
            }),
          );
        } else if (n === "pdp-base") {
          if (a.pdpBaseStatus[t.dataset.base] !== "ready") return;
          a.pdpBase = t.dataset.base;
          const o = V();
          (x(o), h({ noFocus: !0, stable: !0, preservePdpScroll: !0 }));
        } else if (n === "pdp-mode") {
          a.pdpMode = t.dataset.mode;
          const o = V();
          (x(o), h({ noFocus: !0, stable: !0, preservePdpScroll: !0 }));
        } else if (n === "pdp-body") {
          a.pdpBody = t.dataset.body;
          const o = Q(!1)
            .map((r) => A(L(r)))
            .filter((r) => r.mode === "MODULAR" && m(r.body) === m(a.pdpBody))
            .map((r) => r.end);
          (o.some((r) => m(r) === m(a.pdpEnd)) || (a.pdpEnd = o[0] || a.pdpEnd),
            x(V()),
            he({ noFocus: !0, stable: !0, preservePdpScroll: !0 }, !0));
        } else if (n === "pdp-end")
          ((a.pdpEnd = t.dataset.end),
            x(V()),
            he({ noFocus: !0, stable: !0, preservePdpScroll: !0 }, !0));
        else if (n === "pdp-full")
          ((a.pdpFull = t.dataset.full),
            x(V()),
            he({ noFocus: !0, stable: !0, preservePdpScroll: !0 }, !0));
        else if (n === "add-pdp") {
          if (!a.pdpVariant) return;
          const o = a.product.name;
          (await _e(
            [{ id: a.pdpVariant.id, quantity: a.pdpQty }],
            "Added \xB7 " + o,
            t,
          ))
            ? ((a.pdpError = ""),
              window.setTimeout(() => {
                a.product && t.isConnected && (t.textContent = "Add to cart");
              }, 1400))
            : ((a.pdpError =
                "This option could not be added. Please try again."),
              h({ noFocus: !0, stable: !0 }));
        } else if (n === "open-video") {
          const o = f.products[t.dataset.product];
          ((a.video = o
            ? Object.assign({}, o, {
                videoId: t.dataset.videoId || o.videoId,
                videoStart: Number(t.dataset.videoStart) || 0,
              })
            : null),
            h({ stable: !0 }));
        } else if (n === "close-video") ((a.video = null), h({ stable: !0 }));
        else if (n === "close-no-results")
          ((a.noResultsQuery = ""),
            (a.noResultsFormOpen = !1),
            h({ stable: !0 }),
            a.lastFocus && a.lastFocus.focus());
        else if (n === "open-no-results-form") {
          ((a.noResultsFormOpen = !0), h({ noFocus: !0, stable: !0 }));
          const o = _.querySelector(
            '.pcg__no-results-form input[name="contact[name]"]',
          );
          o && o.focus();
        } else if (n === "browse-all-machines") {
          ((a.noResultsQuery = ""),
            (a.noResultsFormOpen = !1),
            (a.query = ""),
            (a.tier = "all"),
            (a.v3Brand = null),
            (a.v3Letter = "all"),
            (v.value = ""),
            s
              .querySelectorAll("[data-pcg-tier]")
              .forEach((r) =>
                r.classList.toggle("is-active", r.dataset.pcgTier === "all"),
              ),
            B(),
            h({ stable: !0 }));
          const o = C ? s.querySelector("[data-pcg-v3-browse]") : g;
          o && o.scrollIntoView({ behavior: "smooth", block: "start" });
        } else
          n === "reset" &&
            ((a.query = ""),
            (a.tier = "all"),
            (a.v3Brand = null),
            (a.v3Letter = "all"),
            (v.value = ""),
            s
              .querySelectorAll("[data-pcg-tier]")
              .forEach((o) =>
                o.classList.toggle("is-active", o.dataset.pcgTier === "all"),
              ),
            B());
      }),
        s.addEventListener("change", (e) => {
          const t = e.target.closest("[data-pcg-option]");
          if (!t || !a.product) return;
          const n = Number(t.dataset.pcgOption);
          a.pdpSelections[n] = t.value;
          const o = Q(!1).find((r) =>
            r.options.every((i, d) => i === a.pdpSelections[d]),
          );
          (x(o || null), h({ noFocus: !0, stable: !0 }));
        }),
        s.addEventListener("click", (e) => {
          const t = e.target.closest("[data-pcg-tier]");
          t &&
            ((a.tier = t.dataset.pcgTier),
            (a.v3Brand = null),
            s
              .querySelectorAll("[data-pcg-tier]")
              .forEach((n) => n.classList.toggle("is-active", n === t)),
            B());
        }),
        v &&
          v.addEventListener("input", () => {
            if (((a.query = v.value), C)) {
              const e = m(a.query),
                t = e
                  ? f.brands.filter(
                      (n) => N(n.name, e) || n.models.some((o) => N(o.name, e)),
                    )
                  : [];
              a.v3Brand = t.length === 1 ? t[0] : null;
            }
            (B(),
              window.clearTimeout(Ue),
              C &&
                a.v3Brand &&
                m(a.query).length >= 2 &&
                (Ue = window.setTimeout(() => {
                  const e = s.querySelector("[data-pcg-v3-model-wrap]");
                  e &&
                    e.scrollIntoView({ behavior: "smooth", block: "center" });
                }, 220)));
          }));
      function tt(e) {
        (e.preventDefault(), (a.query = v.value), C && (a.v3Brand = null), B());
        const t = C ? s.querySelector("[data-pcg-v3-browse]") : g,
          n = g.querySelector(
            '[data-action="select-v3-brand"], [data-action="open-brand"]',
          ),
          o = String(v.value || "").trim();
        if (o && !n) {
          ((a.lastFocus = v),
            (a.noResultsQuery = o),
            (a.noResultsFormOpen = !1),
            h());
          return;
        }
        (t && t.scrollIntoView({ behavior: "smooth", block: "start" }),
          n && n.focus({ preventScroll: !0 }));
      }
      (E && E.addEventListener("submit", tt),
        v &&
          v.addEventListener("keydown", (e) => {
            e.key === "Enter" && !e.isComposing && tt(e);
          }),
        document.addEventListener(
          "pesado:open-portafilter-configurator",
          (e) => {
            const t = e.detail || {},
              n =
                f.products[t.recommendationId] ||
                Object.keys(f.products)
                  .map((r) => f.products[r])
                  .find(
                    (r) =>
                      r && r.cat === "portafilter" && r.handle === t.handle,
                  );
            if (!n) return;
            const o = String(t.fitLabel || "")
              .replace(/^Compatible with(?: your)?\s+/i, "")
              .trim();
            et(n, t.trigger || null, {
              fitLabel: o,
              modelName: t.modelName || o,
              size: t.size || "",
            });
          },
        ),
        document.addEventListener("keydown", (e) => {
          if (
            e.key === "Escape" &&
            (a.brand || a.product || a.video || a.noResultsQuery)
          ) {
            Qt();
            return;
          }
          if (
            e.key !== "Tab" ||
            !(a.brand || a.product || a.video || a.noResultsQuery)
          )
            return;
          const t = _.querySelectorAll('[role="dialog"]'),
            n = t[t.length - 1];
          if (!n) return;
          const o = Array.from(
            n.querySelectorAll(
              'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
            ),
          ).filter((d) => !d.hidden && d.offsetParent !== null);
          if (!o.length) return;
          const r = o[0],
            i = o[o.length - 1];
          e.shiftKey && document.activeElement === r
            ? (e.preventDefault(), i.focus())
            : !e.shiftKey &&
              document.activeElement === i &&
              (e.preventDefault(), r.focus());
        }));
      let at = null;
      function nt(e) {
        (e && e.detail && e.detail.cart === a.cart) ||
          (window.clearTimeout(at), (at = window.setTimeout(ye, 20)));
      }
      (document.addEventListener("cart:updated", nt),
        document.addEventListener("cart:update:count", nt),
        q || B(),
        ye());
      const ot = () => $(Object.keys(f.products));
      "requestIdleCallback" in window
        ? window.requestIdleCallback(ot, { timeout: 1800 })
        : window.setTimeout(ot, 600);
    }
    function xe(s, g) {
      const u = g && g.sessionId;
      return u ? "pesado_" + s + "_view_sent:" + String(u) : "";
    }
    function Pe(s, g) {
      const u = xe(s, g);
      if (!u) return !1;
      try {
        return window.sessionStorage.getItem(u) === "1";
      } catch (v) {
        return !1;
      }
    }
    function Me(s, g) {
      const u = xe(s, g);
      if (u)
        try {
          window.sessionStorage.setItem(u, "1");
        } catch (v) {}
    }
    function st() {
      const s = document.querySelector(".pesado-find-tools-mobile");
      if (!s || s.dataset.pesadoAnalyticsBound === "true") return;
      s.dataset.pesadoAnalyticsBound = "true";
      const g = () => {
        if (s.dataset.pesadoAnalyticsViewed === "true") return !0;
        const u = window.getComputedStyle(s),
          v = s.getBoundingClientRect(),
          E =
            u.display !== "none" &&
            u.visibility !== "hidden" &&
            Number(u.opacity) !== 0 &&
            v.width > 0 &&
            v.height > 0,
          _ = window.PesadoUpgradeAnalytics;
        return !E || !_ || typeof _.track != "function"
          ? !1
          : Pe("bar", _)
            ? ((s.dataset.pesadoAnalyticsViewed = "true"), !0)
            : (_.track("compatibility_bar_view"),
              Me("bar", _),
              (s.dataset.pesadoAnalyticsViewed = "true"),
              !0);
      };
      if (
        (s.addEventListener("click", () => {
          const u = window.PesadoUpgradeAnalytics;
          u &&
            typeof u.track == "function" &&
            u.track("compatibility_bar_click");
        }),
        "IntersectionObserver" in window)
      ) {
        const u = new IntersectionObserver((v) => {
          v.some((E) => E.isIntersecting) && g() && u.disconnect();
        });
        u.observe(s);
      } else window.requestAnimationFrame(g);
    }
    const oe =
      'a[aria-label="Compatibility: find the right tools for your machine"]';
    let re = !1,
      Le = !1,
      ie = !1;
    function Ae() {
      const s = String(window.location.pathname || "").replace(/\/+$/, "");
      return (
        /(?:^|\/)pages\/compatibility-guide$/.test(s) ||
        !!document.querySelector("[data-pcg-root]:not(.pcg--standalone)")
      );
    }
    function Fe(s) {
      const g = window.getComputedStyle(s),
        u = s.getBoundingClientRect();
      return (
        g.display !== "none" &&
        g.visibility !== "hidden" &&
        Number(g.opacity) !== 0 &&
        u.width > 0 &&
        u.height > 0 &&
        u.bottom > 0 &&
        u.right > 0 &&
        u.top < window.innerHeight &&
        u.left < window.innerWidth
      );
    }
    function dt() {
      if (Ae()) return;
      const s = Array.from(document.querySelectorAll(oe));
      if (!s.length) return;
      const g = () => {
        if (re) return !0;
        const u = Array.from(document.querySelectorAll(oe)).some(Fe),
          v = window.PesadoUpgradeAnalytics;
        return !u || !v || typeof v.track != "function"
          ? !1
          : Pe("button", v)
            ? ((re = !0), !0)
            : (v.track("compatibility_button_view"),
              Me("button", v),
              (re = !0),
              !0);
      };
      if (
        (Le ||
          ((Le = !0),
          document.addEventListener("click", (u) => {
            if (Ae() || !(u.target instanceof Element && u.target.closest(oe)))
              return;
            const v = window.PesadoUpgradeAnalytics;
            v &&
              typeof v.track == "function" &&
              v.track("compatibility_button_click");
          })),
        "IntersectionObserver" in window)
      ) {
        const u = new IntersectionObserver((v) => {
          v.some((E) => E.isIntersecting && Fe(E.target)) &&
            g() &&
            u.disconnect();
        });
        s.forEach((v) => u.observe(v));
      } else window.requestAnimationFrame(g);
      if (!ie) {
        ie = !0;
        const u = () => {
          g() && (window.removeEventListener("resize", u), (ie = !1));
        };
        window.addEventListener("resize", u, { passive: !0 });
      }
    }
    function se() {
      (st(), dt());
      const s = document.querySelectorAll("[data-pcg-root]");
      if (s.length) {
        s.forEach(Be);
        return;
      }
      const g = document.createElement("div");
      ((g.className = "pcg pcg--standalone"),
        (g.dataset.pcgRoot = ""),
        (g.dataset.pcgStandalone = "true"),
        (g.dataset.rootUrl =
          window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : "/"),
        (g.dataset.currency =
          window.Shopify && window.Shopify.currency
            ? window.Shopify.currency.active
            : "AUD"),
        (g.dataset.locale = document.documentElement.lang || "en-AU"),
        (g.innerHTML =
          '<div data-pcg-overlays></div><div class="pcg__toast" data-pcg-toast role="status" aria-live="polite" hidden></div>'),
        document.body.appendChild(g),
        Be(g));
    }
    (document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", se)
      : se(),
      document.addEventListener("shopify:section:load", se));
    return true;
  }
  if (
    !initialiseCompatibilityGuide() &&
    window.PesadoCompatibilityReady &&
    typeof window.PesadoCompatibilityReady.then === "function" &&
    !window.PesadoCompatibilityGuideWaiting
  ) {
    window.PesadoCompatibilityGuideWaiting = true;
    window.PesadoCompatibilityReady.then(() => {
      window.PesadoCompatibilityGuideWaiting = false;
      initialiseCompatibilityGuide();
    });
  }
})();
